module.exports = __webpack_public_path__ + "img/mallorca-logo-w&b.e233281d.png";